export default "__VITE_ASSET__BZ_NoE3C__"